import DesktopWindowsOutlinedIcon from '@mui/icons-material/DesktopWindowsOutlined';
import DirectionsWalkIcon from '@mui/icons-material/DirectionsWalk';
import EditIcon from '@mui/icons-material/Edit';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import PhoneAndroidOutlinedIcon from '@mui/icons-material/PhoneAndroidOutlined';
import { Box, Grid, SvgIcon, Dialog, DialogTitle, DialogActions, Button, DialogContent ,CircularProgress} from '@mui/material';
import Card from '@mui/material/Card';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import CardContent from '@mui/material/CardContent';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { format } from "date-fns";
import * as React from 'react';
import AppointmentModal from '../../../../modals/appointment.modal';
import { ApptStatusEnum } from '../../contexts/appointment.context';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Link } from 'react-router-dom';
import CallIcon from '@mui/icons-material/Call';
import appointmentService from '../../../../services/http/appointments/appointment.service';
import Pusher from 'pusher-js';
import { pusherconfig } from '../../../../config/config';
import PrintIcon from '@mui/icons-material/Print';


export interface AppointmentListCardProps extends AppointmentModal {
    isMd: boolean,
    onSelect: Function,
    item: number,
    apptContext: any,
    isHoldable: boolean,
    status: number,
    apptDetails: any,
    sessionType: any,
    ivrNum?: string,
    phoneNum?: string,
    details?: any,
}



export const RequestModeIcon: any = {
    1: <LocalPhoneOutlinedIcon />,
    2: <PhoneAndroidOutlinedIcon />,
    3: <DesktopWindowsOutlinedIcon />,
    4: <DirectionsWalkIcon />
}
class AppointmentListCard extends React.Component<AppointmentListCardProps, any> {

    state = {
        expanded: false,
        isPhoneNumberCopied: false,
        isDialogOpen: false,
        showCallStatus: false,
        callStatus: {
            msg: 'Initiated',
            color: ''
        },
        isCallInitiated: false,
        notificationStatus: 'Pending',
         isPrinting: false,
    }

    constructor(props: any) {
        super(props);

        this.state = {
            expanded: false,
            isPhoneNumberCopied: false,
            isDialogOpen: false,
            showCallStatus: false,
            callStatus: {
                msg: 'Initiated',
                color: '',
            },
            isCallInitiated: false,
            notificationStatus: 'Pending',
             isPrinting: false,
        }
    }

    async componentDidMount() {
       
        console.log('Appointment ID:', this.props.apptDetails.id);

        const apptIdStr = this.props.apptDetails.id.toString();

        const response = await appointmentService.getNotificationStatus(apptIdStr);
                if (response.success) {
                    this.setState({ notificationStatus: response.data.notificationStatus });
                }
        console.log('response from api ',response);

        const pusher = new Pusher(`${pusherconfig.key}`, {
            cluster: `${pusherconfig.cluster}`,
        });

        const channel = pusher.subscribe('call-status');

        channel.bind('call-status-view', (data: any) => {
            console.log('📡 Call Status Update:', data);
            this.setState({ callStatus: { msg: data.msg, color: data.color } });

            // Optional: auto-close after delay
            setTimeout(() => {
                this.setState({ showCallStatus: false });
            }, 6000);
        });

        // ✅ New: Listen for notification status updates
        const notificationChannel = pusher.subscribe('my-channel');
        notificationChannel.bind('my-event', (data: any) => {
            console.log('📡 Notification Status Update:', data);

            if (data.apptId === this.props.apptDetails.id) {
                this.setState({ notificationStatus: data.notificationStatus });
            }
        });
    }
    handleExpandClick = () => {
        this.setState({ ...this.state, expanded: !this.state.expanded });
    };

    showRequestMode() {
        return RequestModeIcon[this.props.requestMode]
    }

    isShowCheckBox = () => {
        const { apptContext, status } = this.props;
        const selectedDate = format(apptContext.filter.scheduleOn, 'yyyy-MM-dd');
        const todayDate = format(new Date(), 'yyyy-MM-dd');
        return (selectedDate >= todayDate && status !== ApptStatusEnum.CANCELLED);
    }


    /**
     * Onclick edit appointment btn
     */
    editApptUserDetails = () => {
        const { apptContext, apptDetails } = this.props;
        apptContext?.setEditApptModal(true);
        apptContext?.setEditSelectedAppt(apptDetails);
    }

    /**
    * Onclick Whatsapp chat open btn
    */

    handleWhatsAppClick = () => {

        const phone = this.props.phoneNumber;
        const whatsappUrl = `https://wa.me/+91${phone}`;
        window.open(whatsappUrl, '_blank')
    }

    handlePrintClick = () => {
    this.setState({ isPrinting: true });
    
    try {
        this.openPrintWindow();
    } catch (error) {
        console.error('Print failed:', error);
        alert('Failed to print appointment. Please try again.');
    } finally {
        this.setState({ isPrinting: false });
    }
};
    openPrintWindow = () => {
        const {apptNumber,requestedOn,name,scheduleTime,phoneNumber,gender,height,weight,apptDetails,bp,hr_spo2} = this.props;
        const printWindow = window.open('', '_blank');
        const {
            drName,
            orgName,
            area,
            AREA
        } = this.props.details

        if (!printWindow) {
            alert('Please allow popups to print');
            return;
        }

       const printContent = `
    <!DOCTYPE html>
    <html>
    <head>
        <title>Token #${apptNumber}</title>
        <meta charset="UTF-8">
        <style>
            * {
                margin: 0;
                padding: 0;
                box-sizing: border-box;
                font-weight: bold !important;
            }
            
            @page {
                size: 80mm auto;
                margin: 0;
            }
            
            body {
                font-family: Arial, Helvetica, sans-serif;
                width: 80mm;
                margin: 0 auto;
                padding: 2mm 3mm;
                background: #fff;
                color: #000;
                font-weight: bold;
            }
            
            .receipt-container {
                width: 100%;
            }
            
            .header {
                text-align: center;
                border-bottom: 2px dashed #000;
                padding-bottom: 4px;
                margin-bottom: 6px;
            }
            
            .header h1 {
                font-size: 18px;
                font-weight: bold;
                margin-bottom: 1px;
                text-transform: uppercase;
            }
            
            .header p {
                font-size: 11px;
                margin: 1px 0;
                font-weight: bold;
            }

            .token-box {
                border: 2px solid #000;
                text-align: center;
                padding: 6px 0;
                margin: 8px 0;
            }

            .token-box .token-label {
                font-size: 12px;
                font-weight: bold;
                text-transform: uppercase;
                letter-spacing: 2px;
            }

            .token-box .token-number {
                font-size: 22px;
                font-weight: bold;
            }
            
            .details {
                margin-top: 6px;
            }
            
            .detail-row {
                display: block;
                padding: 2px 0;
                font-size: 12px;
                font-weight: bold;
            }
            
            .label {
                font-weight: bold;
            }
            
            .value {
                font-weight: bold;
                word-wrap: break-word;
            }
            
            .footer {
                margin-top: 6px;
                padding-top: 4px;
                border-top: 2px dashed #000;
                text-align: center;
                font-size: 9px;
                font-weight: bold;
            }
            
            .note {
                margin-top: 10px;
                padding: 8px;
                background: #f0f0f0;
                border: 1px solid #000;
                font-size: 10px;
                text-align: center;
            }
            
            @media print {
                body {
                    width: 80mm;
                    padding: 2mm 2mm;
                }
            }
        </style>
    </head>
            
            <body>
    <div class="receipt-container">
        <div class="header">
            <h1>DR.${drName}</h1>
            <p>${orgName}</p>
            <p>${area||AREA}</p>
        </div>
        <div class="token-box">
            <div class="token-label">TOKEN</div>
            <div class="token-number">#${apptNumber}</div>
        </div>
        <div class="details">
            ${name ? `<div class="detail-row"><span class="label">Name: </span><span class="value">${name}</span></div>` : ''}
            ${scheduleTime ? `<div class="detail-row"><span class="label">Time: </span><span class="value">${scheduleTime}</span></div>` : ''}
            ${apptDetails.scheduledOn ? `<div class="detail-row"><span class="label">Date: </span><span class="value">${new Date(apptDetails.scheduledOn).toLocaleDateString('en-GB')}</span></div>` : ''}
            ${phoneNumber ? `<div class="detail-row"><span class="label">Phone: </span><span class="value">${phoneNumber}</span></div>` : ''}
            ${gender ? `<div class="detail-row"><span class="label">Gender: </span><span class="value">${gender}</span></div>` : ''}
            ${height ? `<div class="detail-row"><span class="label">Height: </span><span class="value">${height} cm</span></div>` : ''}
            ${weight ? `<div class="detail-row"><span class="label">Weight: </span><span class="value">${weight} kg</span></div>` : ''}
            ${bp ? `<div class="detail-row"><span class="label">BP: </span><span class="value">${bp}</span></div>` : ''}
            ${hr_spo2 ? `<div class="detail-row"><span class="label">HR/SpO2: </span><span class="value">${hr_spo2}</span></div>` : ''}
            ${requestedOn ? `<div class="detail-row"><span class="label">Booked: </span><span class="value">${requestedOn}</span></div>` : ''}
        </div>
        <div class="footer">
            <p>Printed: ${new Date().toLocaleString('en-IN', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
            })}</p>
        </div>
    </div>
    
    <script>
        window.onload = function() {
            setTimeout(() => {
                window.print();
            }, 250);
        };
    </script>
</body>
            </html>
        `;

        printWindow.document.write(printContent);
        printWindow.document.close();
    };

    handleOpenDialog = () => {
        this.setState({ isDialogOpen: true });
    };

    handleCloseDialog = () => {
        this.setState({ isDialogOpen: false });
    };
    handleCloseCallStatusDialog = () => {
        this.setState({ showCallStatus: false, isCallInitiated: false, });
    };

    handleCallClick = async () => {
        this.setState({ isCallInitiated: true, isDialogOpen: false, showCallStatus: true, callStatus: { msg: 'Initiated', color: '' }, });
        // Automatically hide status after 8 seconds
        // setTimeout(() => {
        //     this.setState({ showCallStatus: false });
        // }, 8000);
        const callFrom: any = this.props.phoneNumber; // ensure 10-digit format
        const callTo: any = this.props.ivrNum; // IVR number from UI

        const result = await appointmentService.initiateTwoLegCall(callFrom, callTo, '');

        if (result.success) {
            console.log('Call successfully initiated:', result);
        } else {
            console.error('Call failed:', result.message);
        }
    };





    handleContentCopyClick = () => {
        const { phoneNumber } = this.props;
        navigator.clipboard.writeText(phoneNumber)
            .then(() => {
                console.log("Phone number copied");

                this.setState({ isPhoneNumberCopied: true });
            }
            )
            .catch(error => console.error("Failed to copy phone number:", error));
    }

    handleCloseModal = () => {
        this.setState({ isPhoneNumberCopied: false });
    }



    render(): React.ReactNode {
        const { item, apptContext, isSelect, phoneNumber, sessionType } = this.props;
        const { id, scheduledOn } = this.props.apptDetails;
        const date = scheduledOn.split('T')[0];

        return (
            <>
                <Card sx={{ padding: '0px', width: '100%' }} onDoubleClick={(evt: any) => this.props.onSelect(evt)}>
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>

                        <Grid container sx={{
                            padding: '0rem'
                        }}>
                            <Grid item xs={4} sx={{
                                padding: '0rem',
                                display: 'flex',
                                ...(true && {
                                    background: '#0c3376',
                                    color: '#f9f9f9',
                                    '& .schedule-datetime': {
                                        color: '#f9f9f9',
                                        fontWeight: '400'
                                    }
                                })
                            }} className="appt-number">
                                {/* <Typography component="div" sx={{
                                ...(this.props.isMd && {
                                    display: 'none'
                                })
                            }}>
                                <Checkbox />
                            </Typography> */}

                                <CardContent sx={{
                                    flex: '1 0 auto',
                                    textAlign: 'center',
                                    padding: '15px 15px !important'
                                }}>

                                
                                    <Typography component="div" variant="h3">
                                        {this.props.apptNumber}
                                    </Typography>
                                    <Typography className="schedule-datetime" variant="subtitle2" color="text.secondary" component="div">
                                        <div>{this.props.scheduleDateString}</div>
                                        <div> {this.props.scheduleTime ?? '00:00'}</div>
                                    </Typography>
                                  
                                    <Typography variant="caption" gutterBottom sx={{ fontSize: '8px', mt: '20px', fontWeight: '300', display: 'block' }}>
                                        {this.props.requestedOn}
                                    </Typography>

                                    <Typography variant="caption" gutterBottom sx={{ fontSize: '8px', fontWeight: 'bold', display: 'block', mt: 1 }}>
                                         {this.state.notificationStatus === 'failed' ? 'sms sent' : this.state.notificationStatus}
                                    </Typography>

                                </CardContent>
                                <Typography component="span" sx={{
                                    position: 'relative',
                                    left: '-90%',
                                    top: '5%',
                                }}>
                                    <SvgIcon fontSize="small">{this.showRequestMode()}</SvgIcon>
                                </Typography>
                            </Grid>
                            <Grid item xs={6} sm container sx={{ padding: '0rem' }}>
                                <CardContent sx={{
                                    flex: '1 0 auto', justifyContent: 'center',
                                    padding: '15px 15px !important'
                                }}>

                                    <Typography component="div" variant="h6" >



                                        {phoneNumber ? (
                                            <>
                                                <span>{phoneNumber}</span>
                                                <IconButton aria-label="whatsapp" onClick={this.handleWhatsAppClick}>
                                                    <WhatsAppIcon />
                                                </IconButton>

                                                <IconButton 
                                                    aria-label="print" 
                                                    onClick={this.handlePrintClick}
                                                    disabled={this.state.isPrinting}
                                                    title="Print Appointment"
                                                >
                                                    {this.state.isPrinting ? (
                                                        <CircularProgress size={24} />
                                                    ) : (
                                                        <PrintIcon />
                                                    )}
                                                </IconButton>

                                                {sessionType === 'Online' && (
                                                    <Link to={`/appointment-list/online-payment?apptId=${id}&date=${date}`}>
                                                        <IconButton aria-label="payment">
                                                            <CurrencyRupeeIcon />
                                                        </IconButton>
                                                    </Link>
                                                )}
                                                {sessionType === 'Online' && (
                                                    <IconButton aria-label="copy" onClick={this.handleContentCopyClick}>
                                                        <ContentCopyIcon />
                                                    </IconButton>
                                                )}

                                                {sessionType === 'Online' && this.props.twoLegEnabledDr === 1 && (
                                                    <IconButton
                                                        aria-label="call"
                                                        onClick={this.handleOpenDialog}
                                                    // sx={{
                                                    //     borderRadius: '50%',
                                                    //     ...(this.state.isCallInitiated && {
                                                    //         animation: 'callBuzz 1.2s infinite',
                                                    //         '@keyframes callBuzz': {
                                                    //             '0%': {
                                                    //                 transform: 'scale(1)',
                                                    //                 boxShadow: '0 0 0 0 rgba(0, 255, 0, 0.7)',
                                                    //             },
                                                    //             '70%': {
                                                    //                 transform: 'scale(1.1)',
                                                    //                 boxShadow: '0 0 0 10px rgba(0, 255, 0, 0)',
                                                    //             },
                                                    //             '100%': {
                                                    //                 transform: 'scale(1)',
                                                    //                 boxShadow: '0 0 0 0 rgba(0, 255, 0, 0)',
                                                    //             },
                                                    //         },
                                                    //     }),
                                                    // }}
                                                    >
                                                        <CallIcon />
                                                    </IconButton>

                                                )}


                                            </>
                                        ) : (
                                            <span>-</span>

                                        )}



                                    </Typography>

                                    <Typography sx={{ mt: 1.5 }} component="div" variant="subtitle1" >
                                        {this.props.name ?? 'No Name'}
                                    </Typography>
                                    <Typography sx={{ mt: 1.5 }} color="text.secondary">
                                        Physique
                                    </Typography>
                                    <Typography color="text.primary" variant="subtitle1" component="div">
                                        {this.props.age ?? '- years'} | {this.props.gender ?? '-'} | {this.props.height ?? '- cm'} | {this.props.weight ?? '- kgs'}
                                    </Typography>
                                    {(this.props.bp || this.props.hr_spo2) && (
                                        <Typography color="text.primary" variant="subtitle2" component="div" sx={{ mt: 0.5 }}>
                                            {this.props.bp ? `BP: ${this.props.bp}` : ''}{this.props.bp && this.props.hr_spo2 ? ' | ' : ''}{this.props.hr_spo2 ? `HR/SpO2: ${this.props.hr_spo2}` : ''}
                                        </Typography>
                                    )}
                                </CardContent>
                            </Grid>
                            <Grid container item xs={1}
                                direction="column"
                                justifyContent="space-between"
                                alignItems="flex-end"
                                sx={{ padding: '0rem', ml: this.props.isMd ? 2 : 0, mr: this.props.isMd ? 0 : 1 }}
                            >
                                <Typography color="text.primary" component="div" sx={{ mt: 1.5 }}>
                                    <IconButton onClick={() => this.editApptUserDetails()}>
                                        <SvgIcon fontSize="small"> <EditIcon /></SvgIcon>
                                    </IconButton>
                                </Typography>
                                {
                                    (this.props.isMd && apptContext?.isHoldable && this.isShowCheckBox()) && <Typography component="div" textAlign={"center"}>
                                        <Checkbox
                                            id={`${item}`}
                                            checked={isSelect || false}
                                            onChange={() => apptContext.selectAppointment(item)}
                                            inputProps={{ 'aria-label': 'controlled' }}
                                        />
                                    </Typography>
                                }
                                {
                                    (!this.props.isMd && this.isShowCheckBox()) && <Typography component="div" textAlign={"center"}>
                                        <Checkbox
                                            id={`${item}`}
                                            checked={isSelect || false}
                                            onChange={() => apptContext.selectAppointment(item)}
                                            inputProps={{ 'aria-label': 'controlled' }}
                                        />
                                    </Typography>
                                }
                            </Grid>
                        </Grid>
                    </Box>
                </Card>

                <Dialog
                    open={this.state.isDialogOpen}
                    onClose={this.handleCloseDialog}
                >
                    <DialogTitle>
                        Are you sure you want to initiate call to {phoneNumber}?
                    </DialogTitle>
                    <DialogActions>
                        <Button onClick={this.handleCloseDialog}>Cancel</Button>
                        <Button onClick={this.handleCallClick} variant="contained" color="primary">OK</Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={this.state.showCallStatus} onClose={this.handleCloseCallStatusDialog}>
                    <DialogTitle>📞 Voice call establishing....</DialogTitle>
                    <DialogContent>
                        <Typography gutterBottom>
                            Voice call establishing between 0{phoneNumber} (Patient) and {this.props.phoneNum} (Dr)
                        </Typography>
                        <Typography gutterBottom>
                            Please wait while we are connecting
                        </Typography>

                        <Typography
                            gutterBottom
                            style={{
                                color:
                                    this.state.callStatus.msg === 'Initiated'
                                        ? 'black'
                                        : this.state.callStatus.color === 'Green'
                                            ? 'green'
                                            : 'red',
                                fontWeight: 'bold',
                            }}
                        >
                            Status: {this.state.callStatus.msg}
                        </Typography>

                        <Typography variant="body2" color="textPrimary">
                            <strong>Note:</strong> This will be considered as two outgoing calls and will be charged as per the tariff.
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseCallStatusDialog}>Close</Button>
                    </DialogActions>
                </Dialog>

            </>

        )
    }
}

export default AppointmentListCard;